<template>
  <section>
    <br />
    <div class="columns is-mobile is-centered">
      <div class="column is-half">
        <div class="card" style="width: 400px">
          <header class="card-header">
            <p class="card-header-title">Aanmelden</p>
          </header>
          <div class="card-content" ref="login">
            <div class="field is-horizontal">
              <div class="field-body">
                <div class="field">
                  <div class="control is-expanded has-icons-left">
                    <input class="input" type="email" placeholder="Email-adres" v-model="username" />
                    <span class="icon is-small is-left">
                      <i class="fas fa-envelope"></i>
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div class="field is-horizontal">
              <div class="field-body">
                <div class="field">
                  <div class="control">
                    <input
                      class="input"
                      type="password"
                      placeholder="Wachtwoord"
                      v-model="password"
                    />
                  </div>
                </div>
              </div>
            </div>

            <div class="field is-horizontal">
              <div class="field-body">
                <div class="field">
                  <div class="control">
                    <p style="color: red">{{ getLoginErrorMessage }}</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="field is-horizontal" v-if="user != null">
              <div class="field-body">
                <div class="field">
                  <div class="control">
                    <br />
                    <b-message title="Success" type="is-success">U bent succesvol aangemeld.</b-message>
                  </div>
                </div>
              </div>
            </div>
            <div class="field is-horizontal">
              <div class="field-body">
                <div class="field">
                  <vue-recaptcha
                    sitekey="6LejbMEUAAAAADfu5vt8NYuzJJsSl0rx07bMHJKv"
                    @verify="recaptchaRes = $event"
                    @expired="recaptchaRes = null"
                    size="width:400px"
                  ></vue-recaptcha>
                </div>
              </div>
            </div>
            <div class="field is-horizontal">
              <div class="field-body">
                <div class="field">
                  <div class="control">
                    <button @click="tryLogin" class="button is-primary is-fullwidth">Aanmelden</button>
                  </div>
                </div>
              </div>
            </div>
            <div class="content is-small">
              <table style="width:100%">
                <tr>
                  <td>
                    <a @click="forgotPassword" class="clickable">wachtwoord vergeten?</a>
                  </td>
                  <td style="text-align: right;">
                    <a @click="$router.push('/register')">registreren</a>
                  </td>
                </tr>
              </table>
            </div>
            <div class="field is-horizontal">
              <div class="field-body">
                <div class="field">
                  <div class="control">
                    <p style="color: red">{{ errormsg }}</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="field is-horizontal" v-if="forgotPasswordSucces == true">
              <div class="field-body">
                <div class="field">
                  <div class="control">
                    <br />
                    <b-message title="Success" type="is-success">{{ message }}</b-message>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import VueRecaptcha from 'vue-recaptcha'
import userService from '@/services/userService.js'
import router from '@/router/index.js'

export default {
  components: {
    VueRecaptcha
  },
  data() {
    return {
      username: null, //'dv@atlasabc.nl',
      password: null, //'boom-zaag-56',
      recaptchaRes: null,
      message:
        'Een nieuw wachtwoord is aangevraagd. Open de link in de email die naar uw email-adress is verzonden en verander uw wachtwoord. Let op mogelijk is zit de email in uw spam-folder.',
      forgotPasswordSucces: false,
      errormsg: ''
    }
  },

  computed: {
    ...mapGetters(['user', 'getLoginErrorMessage'])
  },

  methods: {
    ...mapActions(['login']),
    tryLogin() {
      // check user input
      // const loginData = JSON.stringify({ email: this.username, password: this.password })
      const loginData = JSON.stringify({ email: this.username, password: this.password, recaptcha: this.recaptchaRes })
      if (this.recaptchaRes != null) this.login(loginData)
      else console.log('please use the recaptcha widget')
    },
    forgotPassword() {
      const userInfo = new Object()
      userInfo.Email = this.username
      console.log(userInfo)
      let valid = false
      if (this.username != null) {
        valid = /\S+@\S+\.\S+/.test(this.username)
      }
      if (this.username && valid) {
        const res = userService.forgotPassword(userInfo)
        this.forgotPasswordSucces = true
        this.errormsg = ''
      } else {
        this.errormsg = 'Email-adress is niet in het goede format'
      }
    }
  }
}
</script>

<style lang="css" scoped>
section {
  margin-top: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/Auth/AuthLogin.vue